const PM_SELECTOR = '#cart-drawer[data-portamondo-native]';

function initPortamondoCart() {
  const drawer = document.querySelector(PM_SELECTOR);
  if (!drawer || drawer.dataset.pmReady === '1') return;

  const ui = drawer.querySelector('[data-pm-native-root]');
  if (!ui) return;

  drawer.dataset.pmReady = '1';

  const q = (s) => ui.querySelector(s);
  // Traguardi informativi 1+1: continuano anche oltre i primi sei Timbri.
  function soglieBogo(n) {
    const base = n > 0 ? Math.floor((n - 1) / 6) * 6 : 0;
    return [2, 4, 6].map((x) => ({ n: base + x, eti: ((base + x) / 2) + ' gratis' }));
  }
  // La spedizione è sempre gratuita secondo le condizioni del negozio.
  const SPED = 0;
  const MAXQ = 25;
  const VALUTA = window.Shopify?.currency?.active || 'EUR';
  const FETCH = window.fetch.bind(window);

  let TIMBRI = [];
  let occupato = false;
  let C = { righe: [], totale: 0, originale: 0, sconto: 0, conteggio: 0, applicazioni: [] };

  try {
    C = JSON.parse(q('[data-pm-cart]').textContent);
  } catch (e) {}

  function esc(value) {
    const d = document.createElement('div');
    d.textContent = value == null ? '' : String(value);
    return d.innerHTML;
  }

  function fmt(cents) {
    try {
      return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: VALUTA
      }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return ((Number(cents) || 0) / 100).toFixed(2) + ' €';
    }
  }

  function plur(n) {
    return n === 1 ? 'timbro' : 'timbri';
  }

  function props(r) {
    return r && r.properties && typeof r.properties === 'object' ? r.properties : {};
  }

  function ePersonalizzato(r) {
    const p = props(r);
    return !!(
      p._pm_personalizzato ||
      p['Foto da stampare'] ||
      /timbro\s+personalizzat/i.test(r?.titolo || '')
    );
  }

  function eTimbroQualsiasi(r) {
    return (
      (r?.tipo || '').toLowerCase().indexOf('timbro') === 0 ||
      /^PM-T/i.test(r?.sku || '') ||
      /timbro/i.test(r?.titolo || '')
    );
  }

  function eTimbroNormale(r) {
    return eTimbroQualsiasi(r) && !ePersonalizzato(r) && props(r)._pm_ruolo !== 'omaggio';
  }

  function ePassaporto(r) {
    return (
      !eTimbroQualsiasi(r) &&
      (
        props(r)._pm_ruolo === 'supporto' ||
        (r?.tipo || '').toLowerCase().indexOf('passaporto') === 0 ||
        /^PM-(KEY|BRC|NCK)/i.test(r?.sku || '') ||
        /\/products\/passaporto-portachiavi-portamondo(?:[/?#]|$)/i.test(r?.url || '') ||
        /passaporto\s*[–—-]\s*portachiavi\s+portamondo/i.test(r?.titolo || '')
      )
    );
  }

  function nTimbri() {
    return C.righe.reduce((n, r) => n + (eTimbroNormale(r) ? Number(r.q || 0) : 0), 0);
  }

  function haPassaporto() {
    return C.righe.some(ePassaporto);
  }

  function contestoBundle() {
    return nTimbri() > 0 || haPassaporto();
  }

  function oroInCarrello() {
    const t = C.righe.filter(eTimbroNormale);
    return t.length > 0 && t.every((r) => /-ORO$/i.test(r.sku || '') || /oro/i.test(r.variante || ''));
  }

  function fotoRiga(r) {
    const p = props(r);
    let f = p['Foto da stampare'];

    if (typeof f === 'string' && f.trim()) {
      const match = f.match(/https?:\/\/[^\s"'<>]+/i);
      if (match) return match[0];
      if (/^\/\//.test(f)) return 'https:' + f;
      if (/^\//.test(f)) return f;
    }

    return r.img || null;
  }

  function daAjax(cart) {
    return {
      totale: cart.total_price || 0,
      originale: cart.original_total_price || cart.total_price || 0,
      sconto: cart.total_discount || 0,
      conteggio: cart.item_count || 0,
      applicazioni: (cart.cart_level_discount_applications || []).map((a) => ({
        titolo: a.title || a.code || '',
        importo: Number(a.total_allocated_amount || 0)
      })),
      righe: (cart.items || []).map((i) => {
        const vt = i.variant_title || '';
        return {
          key: i.key,
          titolo: i.product_title || i.title || '',
          variante: vt && !vt.includes('Default') ? vt : null,
          sku: i.sku || '',
          tipo: i.product_type || '',
          url: i.url || '#',
          img: i.featured_image?.url || i.image || null,
          q: i.quantity || 0,
          pieno: i.original_line_price || i.final_line_price || 0,
          finale: i.final_line_price || 0,
          allocazioni: (i.line_level_discount_allocations || i.discounts || []).map((a) => ({
            titolo: a.discount_application?.title || a.title || a.code || '',
            importo: Number(a.amount || 0)
          })),
          properties: i.properties || {}
        };
      })
    };
  }

  function showMessage(text) {
    const el = q('[data-status]');
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
  }

  function errore(text) {
    const el = q('[data-errore]');
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
  }

  function setBusy(on) {
    occupato = !!on;
    drawer.toggleAttribute('data-pm-busy', occupato);
  }

  function apri() {
    const native = drawer.querySelector('cart-drawer-component');
    const panel = drawer.querySelector('dialog[ref="panel"]');

    try {
      if (native && typeof native.open === 'function') {
        native.open();
        return;
      }
    } catch (e) {}

    try {
      if (typeof drawer.open === 'function') {
        drawer.open();
        return;
      }
    } catch (e) {}

    try {
      if (panel && !panel.open && typeof panel.showModal === 'function') panel.showModal();
    } catch (e) {}
  }

  function chiudi() {
    const panel = drawer.querySelector('dialog[ref="panel"]');

    try {
      if (typeof drawer.close === 'function') {
        drawer.close();
        return;
      }
    } catch (e) {}

    try {
      if (panel?.open) panel.close();
    } catch (e) {}
  }

  function testata(n, pass) {
    const t = '🎁 Per ogni Timbro, uno è gratis!';
    const regola = ' I meno costosi sono gratis. Vale su qualsiasi quantità, per ogni coppia.';
    if (!n) return { t, s: 'Scegli 2 Timbri standard, ne paghi 1. Aggiungi anche quello in regalo.' + regola };
    if (n % 2) return { t, s: 'Aggiungi 1 Timbro standard per completare la coppia e ottenere un Timbro in regalo.' + regola };
    return { t, s: 'Con ' + n + ' Timbri standard, ' + (n / 2) + (n === 2 ? ' è in regalo.' : ' sono in regalo.') + regola };
  }

  function shippingHtml(solo) {
    return (
      '<div class="pmd-sped' + (solo ? ' pmd-sped--solo' : '') + '" data-on="1">' +
        '<svg width="15" height="15" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.9">' +
          '<path d="M4 10.5l4 4 8-9"/>' +
        '</svg>' +
        '<span>Spedizione gratuita</span>' +
      '</div>'
    );
  }

  function disegnaProg() {
    const box = q('[data-prog]');
    if (!box) return;

    if (!contestoBundle()) {
      box.classList.add('pmd-prog--solo');
      box.innerHTML = shippingHtml(true);
      return;
    }

    box.classList.remove('pmd-prog--solo');

    const n = nTimbri();
    const pass = haPassaporto();
    const h = testata(n, pass);
    const soglie = soglieBogo(n);
    const base = soglie[0].n - 2;
    const pct = Math.min(100, Math.max(0, (n - base) / 6 * 100));
    const pos = [100 / 3, 200 / 3, 100];

    let html =
      '<p class="pmd-prog__t">' + esc(h.t) + '</p>' +
      '<p class="pmd-prog__s">' + esc(h.s) + '</p>';

    if (h.cta) {
      html += '<a class="pmd-cta" href="/collections/passaporti">' + esc(h.cta) + '</a>';
    }

    html += '<div class="pmd-bar"><i style="width:' + pct + '%"></i></div><div class="pmd-scala">';

    soglie.forEach((s, i) => {
      const on = n >= s.n;
      html +=
        '<span style="left:' + pos[i] + '%" data-on="' + (on ? '1' : '0') + '">' +
          '<b>' + (on ? '✓ ' : '') + s.n + '</b>' +
          '<i>' + esc(s.eti) + '</i>' +
        '</span>';
    });

    html += '</div>' + shippingHtml(false);
    box.innerHTML = html;
  }

  function disegnaRighe() {
    const box = q('[data-righe]');
    if (!box) return;

    box.innerHTML = C.righe.map((r) => {
      const sconto = Math.max(0, Number(r.pieno || 0) - Number(r.finale || 0));
      const pers = ePersonalizzato(r);
      const img = fotoRiga(r);

      return (
        '<article class="pmd-r" data-key="' + esc(r.key) + '">' +
          '<span class="pmd-r__f">' +
            (img
              ? '<img src="' + esc(img) + '" alt="" loading="lazy">'
              : '<span class="pmd-ph"></span>') +
          '</span>' +

          '<div class="pmd-r__c">' +
            '<a class="pmd-r__n" href="' + esc(r.url || '#') + '">' + esc(r.titolo) + '</a>' +
            (r.variante ? '<div class="pmd-r__v">' + esc(r.variante) + '</div>' : '') +
            (pers
              ? '<span class="pmd-r__tag">Personalizzato</span>'
              : (sconto > 0 ? '<span class="pmd-r__tag">' + esc(fmt(sconto)) + ' in meno</span>' : '')) +

            '<div class="pmd-r__b">' +
              '<span class="pmd-q">' +
                '<button type="button" data-meno aria-label="Uno in meno">−</button>' +
                '<span>' + Number(r.q || 0) + '</span>' +
                '<button type="button" data-piu aria-label="Uno in più"' + (Number(r.q || 0) >= MAXQ ? ' disabled' : '') + '>+</button>' +
              '</span>' +
              '<span class="pmd-r__p">' +
                (!pers && sconto > 0 ? '<s>' + esc(fmt(r.pieno)) + '</s>' : '') +
                '<b>' + esc(fmt(r.finale)) + '</b>' +
              '</span>' +
            '</div>' +
          '</div>' +

          '<button type="button" class="pmd-via" data-via aria-label="Togli ' + esc(r.titolo) + '">' +
            '<svg width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 5l10 10M15 5L5 15"/></svg>' +
          '</button>' +
        '</article>'
      );
    }).join('');
  }

  // Ripartizione basata sugli sconti RILEVATI da Shopify: niente sconti Passaporto ricostruiti dalle vecchie soglie.
    const PM_CODE = 'PORTAMONDO5';
    const PM_DISCOUNT_SIGNAL = 'pm-discount-signal-v1';
  
    function codiceBenvenutoSegnalato() {
      try {
        const u = new URL(window.location.href);
        if (String(u.searchParams.get('pm_discount') || '').toUpperCase() === PM_CODE) {
          sessionStorage.setItem(PM_DISCOUNT_SIGNAL, PM_CODE);
        }
        if (String(sessionStorage.getItem(PM_DISCOUNT_SIGNAL) || '').toUpperCase() === PM_CODE) return true;
        const cookies = document.cookie.split(';').map((c) => c.trim());
        return ['discount_code', '_shopify_discount'].some((name) => {
          const v = cookies.find((c) => c.startsWith(name + '='));
          if (!v) return false;
          let value = v.slice(name.length + 1);
          try { value = decodeURIComponent(value); } catch (e) {}
          return value.toUpperCase() === PM_CODE;
        });
      } catch (e) { return false; }
    }
  
    function ripartisciSconti() {
      const originale = Math.max(0, Number(C.originale || 0));
      const reale = Math.max(0, Number(C.totale || 0));
      const totaleSconto = Math.max(0, Number(C.sconto || 0), originale - reale);
      const righe = C.righe || [];
      const apps = C.applicazioni || [];
      let codiceRighe = 0, timbriRighe = 0, altroRighe = 0;
  
      righe.forEach((r) => {
        const alloc = r.allocazioni || [];
        if (alloc.length) {
          alloc.forEach((a) => {
            const v = Math.max(0, Number(a.importo || 0));
            if (String(a.titolo || '').toUpperCase().includes(PM_CODE)) codiceRighe += v;
            else if (eTimbroNormale(r)) timbriRighe += v;
            else altroRighe += v;
          });
        } else {
          const v = Math.max(0, Number(r.pieno || 0) - Number(r.finale || 0));
          if (eTimbroNormale(r)) timbriRighe += v;
          else altroRighe += v;
        }
      });
  
      const codiceApp = apps.filter((a) => String(a.titolo || '').toUpperCase().includes(PM_CODE))
        .reduce((n, a) => n + Number(a.importo || 0), 0);
      const tierApp = apps.filter((a) => /timbri|bogo|1\s*\+\s*1|buy\s*1.*get\s*1/i.test(a.titolo || ''))
        .reduce((n, a) => n + Number(a.importo || 0), 0);
      let benvenuto = Math.min(totaleSconto, Math.max(codiceApp, codiceRighe));
      let timbri = Math.min(totaleSconto - benvenuto, Math.max(timbriRighe, tierApp));
      let altri = Math.max(0, totaleSconto - benvenuto - timbri);
  
      // Shopify potrebbe fornire soltanto un totale senza allocazioni nominative.
      // Per evitare false etichette, la parte non riconosciuta rimane "Altri sconti".
      const stimato = codiceBenvenutoSegnalato() && benvenuto === 0
        ? Math.min(reale, Math.round(reale * 0.05))
        : 0;
      return { originale, reale, benvenuto, timbri, altri, stimato,
        visivo: Math.max(0, reale - stimato), totaleSconto };
    }
  
    function disegnaTotali() {
    const box = q('[data-totali]');
    if (!box) return;
    const s = ripartisciSconti();
    const riga = (nome, valore) =>
      '<div class="pmd-riga pmd-riga--sc"><span>' + esc(nome) + '</span><b>−' + esc(fmt(valore)) + '</b></div>';
    let html = '';
    if (s.totaleSconto > 0 || s.stimato > 0) {
      html += '<div class="pmd-riga"><span>Prezzo pieno</span><b>' + esc(fmt(s.originale)) + '</b></div>';
    }
    if (s.timbri) html += riga('Sconto Timbri', s.timbri);
    if (s.benvenuto) html += riga(PM_CODE, s.benvenuto);
    if (s.stimato) html += riga(PM_CODE + ' (stimato)', s.stimato);
    if (s.altri) html += riga('Altri sconti Shopify', s.altri);
    html += '<div class="pmd-riga"><span>Spedizione</span><b>GRATIS</b></div>';
    html += '<div class="pmd-riga pmd-riga--tot"><span>' + (s.stimato ? 'Totale stimato' : 'Totale') +
      '</span><b>' + esc(fmt(s.visivo)) + '</b></div>';
    if (s.stimato) html += '<p class="pmd-estimate">Sconto di benvenuto soggetto a verifica al checkout.</p>';
    box.innerHTML = html;
    const count = q('[data-conta]');
    if (count) count.textContent = C.conteggio === 1 ? '1 articolo' : C.conteggio + ' articoli';
  }

  // Stessa scadenza nella stessa scheda: viene scritta anche dalla PDP.
  // Il timer è solo un promemoria visivo e NON blocca scorte o cancella articoli.
  const PM_TIMER_KEY = 'pm-cart-timer-display-v2';
  const PM_TIMER_MS = 10 * 60 * 1000;
  const pmdTimerWrap = q('[data-pmd-cart-timer]');
  const pmdTimerLabel = q('[data-pmd-time]');
  const pmdPanel = drawer.querySelector('dialog[ref="panel"]');

  function aggiornaTimerDrawer() {
    if (!pmdTimerWrap || !pmdTimerLabel) return;
    const visibile = !!pmdPanel?.open && C.conteggio > 0;
    pmdTimerWrap.hidden = !visibile;
    if (!visibile) return;
    try {
      const now = Date.now();
      let fino = Number(sessionStorage.getItem(PM_TIMER_KEY)) || 0;
      if (!fino || !Number.isFinite(fino)) fino = now + PM_TIMER_MS;
      if (fino <= now) fino += (Math.floor((now - fino) / PM_TIMER_MS) + 1) * PM_TIMER_MS;
      sessionStorage.setItem(PM_TIMER_KEY, String(fino));
      const seconds = Math.ceil((fino - now) / 1000);
      pmdTimerLabel.textContent = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' +
        String(seconds % 60).padStart(2, '0');
    } catch (e) {
      pmdTimerWrap.hidden = true;
    }
  }
  if (pmdPanel) {
    pmdPanel.addEventListener('toggle', aggiornaTimerDrawer);
    const obs = new MutationObserver(aggiornaTimerDrawer);
    obs.observe(pmdPanel, { attributes: true, attributeFilter: ['open'] });
  }
  setInterval(aggiornaTimerDrawer, 1000);

  const POPOLARI = [
    'Italia','Spagna','Francia','Grecia','Portogallo','Paesi Bassi','Regno Unito',
    'Giappone','Thailandia','Indonesia','Stati Uniti','Messico','Marocco','Australia'
  ];

  function giaDentro(t) {
    return C.righe.some((r) => r.sku === t.acc.sku || (t.oro && r.sku === t.oro.sku));
  }

  function varianteGiusta(t) {
    return oroInCarrello() && t.oro ? t.oro : t.acc;
  }

  function disegnaSug() {
    const box = q('[data-cross]');
    const input = q('[data-cerca]');
    const listBox = q('[data-sug]');

    if (!box || !input || !listBox) return;

    if (!contestoBundle() || !TIMBRI.length) {
      box.hidden = true;
      return;
    }

    const search = (input.value || '').trim().toLowerCase();
    let lista = [];

    if (search) {
      lista = TIMBRI
        .filter((t) => t.nome.toLowerCase().includes(search) && !giaDentro(t))
        .slice(0, 5);
    } else {
      POPOLARI.forEach((nome) => {
        if (lista.length >= 3) return;
        const t = TIMBRI.find((x) => x.nome === nome);
        if (t && !giaDentro(t)) lista.push(t);
      });

      if (lista.length < 3) {
        TIMBRI.forEach((t) => {
          if (lista.length < 3 && !giaDentro(t) && !lista.includes(t)) lista.push(t);
        });
      }
    }

    box.hidden = false;

    const n = nTimbri();
    const sub = q('[data-cross-s]');
    if (sub) {
      sub.textContent = n % 2
        ? 'Aggiungi 1 Timbro per completare la coppia: il meno costoso è gratis.'
        : 'Scegli altri 2 Timbri, ne paghi 1. Senza limiti di coppie.';
    }

    listBox.innerHTML = lista.length
      ? lista.map((t) => {
          const v = varianteGiusta(t);
          return (
            '<div class="pmd-s">' +
              '<span class="pmd-s__f">' +
                (t.img ? '<img src="' + esc(t.img) + '" alt="" loading="lazy">' : '<span class="pmd-ph"></span>') +
              '</span>' +
              '<span class="pmd-s__n">' +
                esc(t.nome) +
                '<i>' + esc(fmt(v.prezzo)) + (v === t.oro ? ' · oro' : '') + '</i>' +
              '</span>' +
              '<button type="button" class="pmd-piu" data-agg="' + v.id + '" aria-label="Aggiungi ' + esc(t.nome) + '">+</button>' +
            '</div>'
          );
        }).join('')
      : '<p class="pmd-cross__s">Nessun Paese con questo nome.</p>';
  }

  function caricaTimbri() {
    if (TIMBRI.length || !contestoBundle()) {
      disegnaSug();
      return;
    }

    let out = [];
    let pag = 1;

    function giro() {
      return FETCH('/collections/timbri/products.json?limit=250&page=' + pag, {
        headers: { Accept: 'application/json' }
      })
        .then((r) => r.json())
        .then((d) => {
          const arr = d?.products || [];
          out = out.concat(arr);
          if (arr.length === 250 && pag < 4) {
            pag++;
            return giro();
          }
        });
    }

    giro()
      .then(() => {
        TIMBRI = out
          .filter((p) => !/personalizzat/i.test(p.title || ''))
          .map((p) => {
            let acc = null;
            let oro = null;

            (p.variants || []).forEach((v) => {
              const obj = {
                id: v.id,
                sku: v.sku || '',
                prezzo: Math.round(parseFloat(v.price) * 100)
              };

              if (/oro/i.test(v.title || '')) oro = obj;
              else if (!acc) acc = obj;
            });

            if (!acc) return null;

            const img = p.images?.[0]?.src
              ? p.images[0].src + (p.images[0].src.includes('?') ? '&' : '?') + 'width=100'
              : null;

            const t = {
              nome: (p.title || '').replace(/^Timbro\s+/i, ''),
              img,
              acc
            };

            if (oro) t.oro = oro;
            return t;
          })
          .filter(Boolean);

        disegnaSug();
      })
      .catch(() => {});
  }

  function disegna() {
    const vuoto = !C.righe.length;

    q('[data-vuoto]').hidden = !vuoto;
    q('[data-pieno]').hidden = vuoto;
    q('[data-piede]').hidden = vuoto;

    if (vuoto) {
      const count = q('[data-conta]');
      if (count) count.textContent = '0 articoli';
      return;
    }

    disegnaProg();
    disegnaRighe();
    disegnaTotali();
    aggiornaTimerDrawer();

    if (contestoBundle()) caricaTimbri();
    else {
      const cross = q('[data-cross]');
      if (cross) cross.hidden = true;
    }
  }

  function notifyCart(cart) {
    try {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          cart,
          data: {
            itemCount: cart.item_count,
            source: 'portamondo-native'
          }
        }
      }));
    } catch (e) {}
  }

  function aggiorna(apriDopo) {
    return FETCH('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => {
        if (!r.ok) throw new Error('Impossibile aggiornare il carrello');
        return r.json();
      })
      .then((cart) => {
        C = daAjax(cart);
        disegna();
        if (apriDopo) apri();
        return cart;
      })
      .catch(() => null);
  }

  function chiedi(url, body) {
    if (occupato) return Promise.resolve(null);

    setBusy(true);
    errore('');
    showMessage('');

    return FETCH(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    })
      .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.data?.description || res.data?.message || 'Qualcosa non ha funzionato');
        }

        return FETCH('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then((r) => r.json())
      .then((cart) => {
        C = daAjax(cart);
        disegna();
        notifyCart(cart);
        setBusy(false);
        return cart;
      })
      .catch((err) => {
        setBusy(false);
        errore((err?.message || 'Qualcosa non ha funzionato') + ' — riprova.');
        return null;
      });
  }

  ui.addEventListener('click', (e) => {
    const add = e.target.closest('[data-agg]');
    if (add) {
      chiedi('/cart/add.js', {
        items: [{ id: parseInt(add.dataset.agg, 10), quantity: 1 }]
      });
      return;
    }

    const row = e.target.closest('[data-key]');
    if (!row) return;

    const key = row.dataset.key;
    const r = C.righe.find((x) => x.key === key);
    if (!r) return;

    if (e.target.closest('[data-via]')) {
      chiedi('/cart/change.js', { id: key, quantity: 0 });
      return;
    }

    if (e.target.closest('[data-meno]')) {
      chiedi('/cart/change.js', { id: key, quantity: Math.max(0, Number(r.q || 0) - 1) });
      return;
    }

    if (e.target.closest('[data-piu]') && Number(r.q || 0) < MAXQ) {
      chiedi('/cart/change.js', { id: key, quantity: Number(r.q || 0) + 1 });
    }
  });

  q('[data-cerca]')?.addEventListener('input', disegnaSug);

  // Mantiene la UI PortaMondo sincronizzata anche quando il carrello viene
  // modificato da PDP, configuratore o codice Horizon.
  if (!window.__PM_NATIVE_FETCH_PATCHED) {
    window.__PM_NATIVE_FETCH_PATCHED = true;
    const original = window.fetch;

    window.fetch = function () {
      const result = original.apply(this, arguments);

      try {
        const req = arguments[0];
        const url = req?.url ? req.url : String(req || '');

        if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url)) {
          const isAdd = /\/cart\/add/.test(url);

          result.then((res) => {
            if (!res?.ok) return;

            setTimeout(() => {
              aggiorna(isAdd && window.PM_CASSETTO_AUTO !== false);
            }, 45);
          }).catch(() => {});
        }
      } catch (e) {}

      return result;
    };
  }

  // Eventi usati da Horizon e dalla PDP personalizzata.
  document.addEventListener('cart:update', (e) => {
    if (e?.detail?.data?.source === 'portamondo-native') return;
    setTimeout(() => aggiorna(false), 20);
  });

  document.addEventListener('portamondo:cart-refresh', () => {
    setTimeout(() => aggiorna(false), 10);
  });

  window.PortamondoCassetto = {
    apri,
    open: apri,
    chiudi,
    close: chiudi,
    aggiorna: function () {
      return aggiorna(false);
    },
    refresh: function () {
      return aggiorna(false);
    }
  };

  disegna();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPortamondoCart, { once: true });
} else {
  initPortamondoCart();
}

document.addEventListener('shopify:section:load', initPortamondoCart);